<ng-container *ngIf="(!(isLoading$ | async) && (count$ | async)==0); else templateResult">
  <div class="noResult">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <i style="font-size: 40px;color: #0c8efe;" class="fa fa-shopping-basket"></i>
          <h5 style="font-style: normal !important">
            Productos no encontrados.
          </h5>
          <h6 style="padding: 5px;">
            No encontramos resultados.
            Por favor, revise los criterios de búsqueda.
          </h6>
          <a href="market/productos-compras-cuba-online"
            style="color: #007bff !important;text-decoration: underline !important;">
            Ver productos
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #templateResult>

  <div class="row">
    <!-- Loader -->
    <ng-container *ngIf="isLoading$ | async ; else template">
      <div *ngFor="let product of [1,2,3,4,5,6,7,8,9,10,11,12]" style="display:flex;" class="col-lg-3 col-6">
        <div class="tab-item">
          <div class="tab-img">

            <ngx-skeleton-loader animation="progress" animation="true" appearance="line" [theme]="theme">
            </ngx-skeleton-loader>

          </div>
          <div style="min-height: 80px;" class="tab-heading">

            <ngx-skeleton-loader animation="progress" appearance="line"
              [theme]="{ margin: '-15px 0 0 10px', width: '160px', height: '28px',background: '#f1f1f1'}">
            </ngx-skeleton-loader>

            <ngx-skeleton-loader animation="progress" appearance="line"
              [theme]="{ margin: '0 0 0 10px', width: '110px', height: '20px',background: '#f1f1f1'}">
            </ngx-skeleton-loader>

          </div>

          <div class="img-content d-flex justify-content-between">
            <div style="margin-top:10px">
              <ngx-skeleton-loader animation="progress" appearance="line"
                [theme]="{ margin: '5px 0 0 0px', width: '120px', height: '30px',background: '#f1f1f1'}">
              </ngx-skeleton-loader>
            </div>
            <div>
              <ngx-skeleton-loader animation="progress" appearance="circle"
                [theme]="{ width: '50px', height: '50px',background: '#f1f1f1'}">
              </ngx-skeleton-loader>
            </div>
          </div>


        </div>
      </div>
    </ng-container>
    <!-- End Loader -->

    <!-- Product Tab1 -->
    <ng-template #template>
      <div *ngFor="let product of data$ | async; let index = index;" style="display:flex;" class="col-lg-3 col-6 items">
        <div id="{{product.code}}" class="tab-item">


          <div class="tab-img d-flex justify-content-center">

            <ngx-skeleton-loader [hidden]="product.loaded" animation="progress" appearance="line" [theme]="theme">
            </ngx-skeleton-loader>

            <img *ngIf="product.provider==0" routerLink='/market/productos-compras-cuba-online/cubatel/{{product.code}}' style="max-height: 300px"
              [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
              src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
              (load)="product.loaded=true">

            <img *ngIf="product.provider==1" routerLink='/market/productos-compras-cuba-online/amazon/{{product.code}}' style="max-height: 300px"
              [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
              src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
              (load)="product.loaded=true">

            <img *ngIf="product.provider==2" routerLink='/market/productos-compras-cuba-online/shein/{{product.code}}' style="max-height: 300px"
              [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
              src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
              (load)="product.loaded=true">

              <img *ngIf="product.provider==3" routerLink='/market/productos-compras-cuba-online/walmart/{{product.code}}' style="max-height: 300px"
              [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
              src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
              (load)="product.loaded=true">

              <img *ngIf="product.provider==4" routerLink='/market/productos-compras-cuba-online/homedepot/{{product.code}}' style="max-height: 300px"
              [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
              src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
              (load)="product.loaded=true">

              <img *ngIf="product.provider==5" routerLink='/market/productos-compras-cuba-online/bestbuy/{{product.code}}' style="max-height: 300px"
              [hidden]="!product.loaded" class="main-img img-fluid tab1-product-img"
              src="{{product.pictures.length>0?product.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
              (load)="product.loaded=true">

          </div>

          <div style="min-height: 80px;" class="tab-heading">
            <h3 *ngIf="product.provider==0">
              <a routerLink='/market/productos-compras-cuba-online/cubatel/{{product.code}}'>
                {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
              </a>
            </h3>

            <h3 *ngIf="product.provider==1">
              <a routerLink='/market/productos-compras-cuba-online/amazon/{{product.code}}'>
                {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
              </a>
            </h3>

            <p *ngIf="product.provider==2">
              <a routerLink='/market/productos-compras-cuba-online/shein/{{product.code}}'>
                {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
              </a>
            </p>

            <p *ngIf="product.provider==3">
              <a routerLink='/market/productos-compras-cuba-online/walmart/{{product.code}}'>
                {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
              </a>
            </p>

            <p *ngIf="product.provider==4">
              <a routerLink='/market/productos-compras-cuba-online/homedepot/{{product.code}}'>
                {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
              </a>
            </p>

            <p *ngIf="product.provider==5">
              <a routerLink='/market/productos-compras-cuba-online/bestbuy/{{product.code}}'>
                {{ (product.name.length>50)? (product.name | slice:0:50)+'...':(product.name) }}
              </a>
            </p>

            <div class="img-content d-flex justify-content-between">
              <ul title="{{product.rating}}" [innerHtml]="product.rating | start" class="list-unstyled list-inline fav">
              </ul>
            </div>
          </div>

          <div class="img-content d-flex justify-content-between">
            <div style="margin-top:10px">
              <ul class="list-unstyled list-inline price">
                <li class="list-inline-item">{{product.priceToShow}}</li>
                <li class="list-inline-item">{{product.oldPriceToShow}}</li>
              </ul>
            </div>

            <div *ngIf="product.productProvider==2">
              <a class="my-btn" href="javascript:void(0)" data-toggle="tooltip" data-placement="top"
                title="Añadir al carrito"
                (click)="openDetails(product)">
                <i class="fa fa-shopping-cart"></i>
              </a>
            </div>

            <div *ngIf="product.productProvider!=2">
              <a class="my-btn" href="javascript:void(0)" data-toggle="tooltip" data-placement="top"
                title="Añadir al carrito"
                (click)="pushToCart(product)">
                <i class="fa fa-shopping-cart"></i>
              </a>
            </div>

          </div>

          <div *ngIf="product.provider==1" class="amazon-item">
            <img src="assets/amazon-logo.svg" alt="Amazon">
          </div>

          <div *ngIf="product.provider==2" class="amazon-item">
            <img src="assets/shein-logo.svg" alt="Shein">
          </div>

          <div *ngIf="product.provider==3" class="amazon-item">
            <img src="assets/walmart-icon.svg" alt="Shein">
          </div>

          <div *ngIf="product.provider==4" class="amazon-item">
            <img src="assets/homedepot-logo.svg" alt="HomeDepot">
          </div>

          <div *ngIf="product.provider==5" class="amazon-item">
            <img src="assets/bestbuy-icon.svg" alt="BestBuy">
          </div>

        </div>
      </div>
    </ng-template>

  </div>

</ng-template>

<div class="cloneImg"></div>
